<template>
  <div
    class="product-listing-containers"
    :style="{
      backgroundImage: 'url(' + productListingData.Image + ')',
    }"
  >
    <div
      class="inner-container"
      :class="productListingData.ColumnPosition === 'right' && 'move-right'"
    >
      <div class="productlistingdatadesc">
        <p v-html="productListingData.Description"></p>
      </div>
      <div class="button-container" @click="CTATagging()">
        <a :href="productListingData.ArtcleUrl" role="button">
          <strong>{{ productListingData.ButtonText }}</strong>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'product-listing',
  props: {
    productListingData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {};
  },
  methods: {
    CTATagging() {
      dataLayer.push({
        event: 'uaevent',
        eventCategory: 'product selector page',
        eventAction: `select::product selector page`,
        eventLabel: `${this.productListingData.ButtonText}::${this.productListingData.ArtcleUrl}`,
        ecommerce: 'undefined',
        event_name: 'body_button_click',
        module_name: 'product selector page',
        cta_name: this.productListingData.ButtonText,
        link_url: this.productListingData.ArtcleUrl,
      });
    },
  },
};
</script>
